<template>
  <div>
    <Breadcrumb :title="'Document Upload'"></Breadcrumb>
    <div class="row no-gutters">
      <div class="col">
        <button
          class="btn btn-secondary"
          style="float:right;"
          @click.prevent="GoToDocumentManager"
        ><span class="k-icon k-i-dictionary-add"></span>&nbsp; View All Dcouments</button>
      </div>
    </div>
    <br>
    <BaseDropzone :id="'drop'" @change="_change" @Remove="_remove" :File="inputfile"  :UploadType="FileUploadType"></BaseDropzone>
    <BaseToolbar
      :config="dropZoneGridToolBarConfig"
      @buttonClicked="dropZoneGridToolBarClick"
      v-show="DisplayGrid"
    ></BaseToolbar>
    <BaseGrid
      :mode="'inline'"
      :excelExport="excelExport"
      :config="dropZoneGridConfig"
      :dropdownOptions="dropdownOptions"
      :data="Files"
      v-show="DisplayGrid"
    ></BaseGrid>
  </div>
</template>

<script>
import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import BaseDropzone from "@/components/base/BaseDropzone.vue";
import BaseToolbar from "@/components/base/BaseToolbar.vue";
import BaseGrid from "@/components/base/BaseGrid.vue";
import  { DropZoneGridConfig, DropZoneGridToolBarConfig } from "./DocumentDropoffConfig.js";
//import    from "@/models/BaseModelDropZoneToolBar.js";
import toolbarUtility from "@/services/toolbarUtility.js";
import apiutil from "@/services/apiUtil.js";
import funcUtil from "@/services/funcUtil.js";
import BaseModelProgram from "@/models/BaseModelProgram.js";
import BaseModelPartner from "@/models/BaseModelPartner.js";
import _ from "lodash";
import {mapGetters, mapActions, mapState } from 'vuex';
import BaseModelInputControl from "@/models/BaseModelInputControl.js";
import DocumentManagerMixin from "@/mixins/DocumentManagerMixin.js"

export default {
  name: "DocumentDropoff",
  mixins: [toolbarUtility, apiutil,funcUtil,DocumentManagerMixin],
  computed: {
    ...mapGetters("getModule",["withFilter","getLocalInputControls"]),
    ...mapState("postModule",["response"]),
    DisplayGrid() {
      return this.Files.length > 0 ? true : false;
    }
  },
  components: {
    Breadcrumb,
    BaseGrid,
    BaseDropzone,
    BaseToolbar
  },
  data: function() {
    return {
      dropZoneGridConfig: DropZoneGridConfig,
      dropZoneGridToolBarConfig: DropZoneGridToolBarConfig,
      BaseModelInputControl: BaseModelInputControl,
      inputfile: {
        UploadFile: {}
      },
      FileUploadType:{
            AllowMultiple: true
            },
      Files: [],
      count: 1,
      dropdownOptions: {},
      gridId:"dropZoneGrid",
      BusinessEvent:[
        {"Option":"Generic"},
        {"Option":"Program"},
        {"Option":"Partner"},

        ]
    };
  },
  methods: {
    ...mapActions("postModule",['PostAllFilesAndUpdateMetadata']),
    dropZoneGridToolBarClick(e) {
      let self = this;

      let grid = $("#dropZoneGrid").data("kendoGrid");
      let selectedFileCount=0;

      if (e.id === "btnUpload") {
        let FileUpload = [];
        let flgSelected = true;
        let invalidFileName = "";

        grid.select().each(function() {
          if (
            //grid.dataItem(this).ProgramTitle == "Please Select" ||
           // grid.dataItem(this).PartnerTitle == "Please Select" ||
            grid.dataItem(this).DocumentType == "Please Select" ||
            grid.dataItem(this).BusinessEvent == "Please Select"
          ) {
            flgSelected = false;
            invalidFileName = invalidFileName + grid.dataItem(this).File + ", ";
          } else {
            //console.log(grid.dataItem(this));
            let selectedFile={...grid.dataItem(this)};
            //Add EntityId based on the Entity with the Posted Document
            selectedFile.ProgramId= self.getId(selectedFile.ProgramTitle,"ProgramTitle");
            selectedFile.PartnerId= self.getId(selectedFile.PartnerTitle,"PartnerTitle");
            selectedFile.BatchGUID=0

            console.log(selectedFile)
            //grid.saveChanges();s

            FileUpload.push(selectedFile);
          }
          selectedFileCount++;
        });

        this.UploadFilesToDB(flgSelected,selectedFileCount,FileUpload,invalidFileName,"AdminDropZone");

      } else if (e.id === "btnDelete") {

        this.DeleteGridRows(grid,selectedFileCount);

      } else if (e.id === "btnReset") {
        //console.log("Reset Button Clicked");
          this.ResetGrid();
      }
      //this._baseToolBarEvents("dropZoneGrid", ...arguments);
    },
    _change(evt) {
      //When the Files are Uploaded in the Drop Zone. Need to take care of the existing data in the grid
      //TODO
      // 1. Get the grid data which user might have modified
      let currentGridDataArray = this.getCurrentDataFromGrid("dropZoneGrid");

      // 2. push the new files uploaded in the drop zone
      this.inputfile.UploadFile.forEach(obj => {
        let arrayobj = {};
        arrayobj.Id = this.count++;
        arrayobj.File = obj.name;
        arrayobj.ProgramTitle = "Please Select";
        arrayobj.PartnerTitle = "Please Select";
        arrayobj.DocumentType = "Please Select";
        arrayobj.BusinessEvent = "Please Select";
        arrayobj.Status = "Pending";
        arrayobj.FileContent = obj;
        currentGridDataArray.push(arrayobj);
      });
      this.Files = currentGridDataArray;

      console.log(this.Files);
    },
    _remove(evt) {
      console.log(this.inputfile.UploadFile);
    },
    getId(Title,Column){
      let index=_.findIndex(this.dropdownOptions[Column], function(o) { return o.Option == Title; })
      if(index>=0){
        return this.dropdownOptions[Column][index].Id
      }else{
        return null;
      }	
	  },
    GoToDocumentManager(){
      this.$router.push("/admin/document");
    }
  },
  mounted() {
    let grid = $("#dropZoneGrid").data("kendoGrid");    
    grid.bind("dataBound", this.dropZoneGridDataBound);
    
    this.getInputControls("AdminDropZone");

  //Get Dropdown Values for BusinessEvent ( Document Level)
    this.dropdownOptions["BusinessEvent"] = this.BusinessEvent;
	//Get Dropdown Values for ProgramTitle and push required Options in dropdownOptions 
    let programResponse = this.withFilter(BaseModelProgram.list);
      if (programResponse) {
        let Program = [];
        programResponse.forEach(item => {
          let obj = {};
          obj.Id = item.Id;
          obj.Option = item.Title;
          Program.push(obj);
        });
        this.dropdownOptions["ProgramTitle"] = Program;
      }
  //Get Dropdown Values for PartnerTitle and push required Options in dropdownOptions
    let partnerResponse = this.withFilter(BaseModelPartner.list);
      if (partnerResponse) {
        let Partner = [];
        partnerResponse.forEach(item => {
          let obj = {};
          obj.Id = item.Id;
          obj.Option = item.FullName;
          Partner.push(obj);
        });
        this.dropdownOptions["PartnerTitle"] = Partner;
      }
  }
};
</script>
<style>
.disableRow{
  opacity:0.7;
  pointer-events:none;
}
</style>
